import {createAsyncThunk, createSlice, current} from '@reduxjs/toolkit';
import {
    deleteStationApi,
    getStationApi,
    getStationByIDAPI,
    insertStationApi,
    searchStationApi,
    updateStationApi
} from "../../api/backendAPIs";

export const searchStation = createAsyncThunk('searchStation', async (payload) => {
    return await searchStationApi(payload)
})

export const getStationById = createAsyncThunk('searchStationById', async (payload) => {
    return await getStationByIDAPI(payload)
})


export const fetchStations = createAsyncThunk('fetchStations', async () => {
    return getStationApi();
})

export const insertStation = createAsyncThunk('insertStation', async (payload) => {
    return insertStationApi(payload);
})

export const updateStation = createAsyncThunk('updateStation', async (payload) => {
    return updateStationApi(payload);
})

export const deleteStation = createAsyncThunk('deleteStation', async (id) => {
    return deleteStationApi(id);
})

const initialState = {
    query: '',
    stationDepartures: [],
    idOfStartStation: null,
    stations: [],
    loadingStations: false,
    searchParam: ""
}

export const stationSlice = createSlice({
    name: 'stations',
    initialState,
    reducers: {
        setQuery: (state, action) => {
            state.query = action.payload;
        },
    },
    extraReducers: {
        [searchStation.pending]: (state) => {
            state.loadingStations = true;
        },
        [searchStation.fulfilled]: (state, {payload}) => {
            state.loadingStations = false;
            state.stations = payload.data.content;
        },
        [searchStation.rejected]: (state) => {
            state.loadingStations = false;
        },
        [fetchStations.pending]: (state) => {
            state.loadingStations = true;
        },
        [fetchStations.fulfilled]: (state, {payload}) => {
            state.stations = payload.data.content;
            state.loadingStations = false;
        },
        [fetchStations.rejected]: (state) => {
            state.loadingStations = false;
        },
        [getStationById.pending]: (state) => {
            state.loadingStations = true;
        },
        [getStationById.fulfilled]: (state, {payload}) => {
            state.loadingStations = false;
            let arr = state.stations
            let obj = payload.data
            if (arr.some(e => e.id === payload.data.id)) {

            } else {

                arr.push(obj)
            }

            state.stations = arr
        },
        [getStationById.rejected]: (state) => {
            state.loadingStations = false;
        },
        [deleteStation.pending]: (state) => {
            state.loadingStations = true;
        },
        [deleteStation.fulfilled]: (state, action) => {
            let arr = [...current(state.stations)]
            let index = arr.findIndex(i => i.id === action.meta.arg)
            if (index !== -1) {
                arr.splice(index, 1)
                state.stations = arr
            }
            state.loadingStations = false;
        },
        [deleteStation.rejected]: (state) => {
            state.loadingStations = false;
        },
        [updateStation.pending]: (state) => {
            state.loadingStations = false;
        },
        [updateStation.fulfilled]: (state, {payload}) => {
            const arr = [...current(state.stations)]
            const index = arr.findIndex(o => o.id === payload.data.id)
            if (index !== -1) {
                arr[index] = payload.data
                state.stations = arr
            }
            state.loadingStations = false;
        },
        [updateStation.rejected]: (state) => {
            state.loadingStations = false;
        },
        [insertStation.pending]: (state) => {
            state.loadingStations = false;
        },
        [insertStation.fulfilled]: (state, {payload}) => {
            const arr = [...current(state.stations)];
            arr.push(payload.data)
            state.stations = arr
            state.loadingStations = false;
        },
        [insertStation.rejected]: (state) => {
            state.loadingStations = false;
        },
    }
});

export const stationsReducer = stationSlice.reducer
